import React from 'react';

export default function VIPAgreement() {
  return (
    <div className="bg-gray-50 rounded-md p-6 max-h-96 overflow-y-auto text-sm text-gray-700 space-y-4 border border-gray-200">
      <div className="text-center mb-4">
        <h4 className="font-bold text-gray-900 text-lg">VinoSeeker VIP Partner Agreement</h4>
      </div>

      <div>
        <p className="font-medium text-gray-900">Purpose:</p>
        <p>This agreement allows your winery to participate in the VinoSeeker VIP Network and offer benefits to VinoSeeker VIP Members.</p>
      </div>

      <div className="border-t border-gray-300 pt-4">
        <h5 className="font-semibold text-gray-900 mb-3">Winery Agrees To:</h5>

        <div className="space-y-3 ml-2">
          <div>
            <p className="font-medium text-gray-900">1. Offer VIP Benefits:</p>
            <p className="ml-4">Provide the following benefit(s) to VinoSeeker VIP Members who present valid membership credentials:</p>
            <ul className="list-disc list-inside ml-8 mt-1">
              <li>Buy-one-get-one tastings</li>
              <li>10% off bottle purchases</li>
            </ul>
          </div>

          <div>
            <p className="font-medium text-gray-900">2. Honor Benefits Consistently:</p>
            <p className="ml-4">VIP benefits must be honored during regular tasting room hours, subject only to capacity limitations or appointment requirements that apply to all guests.</p>
          </div>

          <div>
            <p className="font-medium text-gray-900">3. Minimum Commitment:</p>
            <p className="ml-4">Participate in the VIP Network for at least 6 months from enrollment date.</p>
          </div>

          <div>
            <p className="font-medium text-gray-900">4. Usage Limits:</p>
            <p className="ml-4">VIP members may redeem benefits at your winery once per 6-month period.</p>
          </div>

          <div>
            <p className="font-medium text-gray-900">5. Verification:</p>
            <p className="ml-4">Staff will verify VIP membership via the VinoSeeker app before applying benefits.</p>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-300 pt-4">
        <h5 className="font-semibold text-gray-900 mb-3">VinoSeeker Agrees To:</h5>

        <div className="space-y-3 ml-2">
          <div>
            <p className="font-medium text-gray-900">1. Promote Your Winery:</p>
            <p className="ml-4">Display a VIP badge on your listing and include you in VIP winery filters.</p>
          </div>

          <div>
            <p className="font-medium text-gray-900">2. Drive Qualified Traffic:</p>
            <p className="ml-4">Market the VIP program to wine enthusiasts who are active winery visitors.</p>
          </div>

          <div>
            <p className="font-medium text-gray-900">3. Provide Tools:</p>
            <p className="ml-4">Supply QR codes, promotional materials, and redemption tracking.</p>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-300 pt-4">
        <h5 className="font-semibold text-gray-900 mb-3">Terms:</h5>

        <ul className="space-y-2 ml-2">
          <li><span className="font-medium">No Cost:</span> Participation in the VIP Network is free.</li>
          <li><span className="font-medium">Opt-Out:</span> Either party may terminate participation with 30 days written notice.</li>
          <li><span className="font-medium">Modification:</span> VIP benefits may be modified with 30 days notice to VinoSeeker.</li>
          <li><span className="font-medium">No Guarantee:</span> VinoSeeker makes no guarantee of visitor volume.</li>
        </ul>
      </div>

      <div className="border-t border-gray-300 pt-4">
        <h5 className="font-semibold text-gray-900 mb-3">Data & Privacy:</h5>

        <ul className="space-y-2 ml-2">
          <li>Redemption data (date, time, user name) will be shared with winery for verification purposes only.</li>
          <li>User contact information remains private unless user opts into winery's mailing list.</li>
        </ul>
      </div>

      <div className="border-t border-gray-300 pt-4 text-xs text-gray-500">
        <p>By checking the agreement box and clicking "Join VIP Network," you confirm that you are authorized to bind your winery to this agreement.</p>
        <p className="mt-2">Last updated: October 2025</p>
      </div>
    </div>
  );
}
